import { mappedArray } from '@10000/common'
import { useView } from '@10000/react'
import { Body, Box } from '../../widgets'
import { questions, valueColors, valueTextColors } from '../../../lookups'

export const AnswerCards = () => {
  const { question } = useView('squiz')

  return (
    <Box column gap={16}>
      {mappedArray(6, answer =>
        <AnswerCard
          key={answer}
          question={question}
          answer={answer}
        />
      )}
    </Box>
  )
}

const AnswerCard = ({ question, answer }) => (
  <Box
    fullWidth
    p={16}
    r={16}
    border="1px solid white"
    shadow="2px 2px 0 0 white"
    background={valueColors[answer]}
    color={valueTextColors[answer]}
  >
    <Body size={24}>{questions[question]?.consensus?.answers[answer] || questions[question]?.answers[answer]}</Body>
  </Box>
)